import React, { useState } from "react";
import { MiniBar } from "./irrigationHelpers";

const VIEWS = ["Daily", "Weekly", "Zone Comparison", "Cycle History"];

const IrrAnalyticsPanel = ({ d }) => {
  const [view, setView] = useState("Daily");

  const maxDaily   = Math.max(...d.analytics.daily.map(x => x.water));
  const maxWeekly  = Math.max(...d.analytics.weekly.map(x => x.water));
  const maxZone    = Math.max(...d.analytics.zoneComparison.map(x => x.water), 1);

  return (
    <div className="irr-analytics-panel">

      {/* View toggle */}
      <div className="irr-view-row">
        {VIEWS.map(v => (
          <button key={v} className={`irr-view-btn ${view === v ? "irr-view-active" : ""}`} onClick={() => setView(v)}>{v}</button>
        ))}
      </div>

      {/* AI insight strip */}
      <div className="irr-ai-strip">
        💧 AI: Zone 4 (Pomegranate B) consumed 18% more water than zone average this week. Consider reducing target moisture.
      </div>

      {/* ── Daily view ── */}
      {view === "Daily" && (
        <div className="irr-chart-card">
          <div className="irr-section-title">Daily Water Usage — Last 7 Days</div>
          <div className="irr-bar-chart" style={{ height: 200 }}>
            {d.analytics.daily.map(day => (
              <div key={day.day} className="irr-bar-col">
                <div className="irr-bar-val">{(day.water / 1000).toFixed(1)}k</div>
                <div className="irr-bar-wrap">
                  <div className="irr-bar-fill" style={{ height: `${(day.water / maxDaily) * 100}%`, background: "linear-gradient(180deg,#10b981,#059669)" }} />
                </div>
                <div className="irr-bar-lbl">{day.day}</div>
              </div>
            ))}
          </div>
          <div className="irr-chart-footer">Total this week: {(d.summary.waterUsedThisWeek / 1000).toFixed(0)} kL</div>
        </div>
      )}

      {/* ── Weekly view ── */}
      {view === "Weekly" && (
        <div className="irr-chart-card">
          <div className="irr-section-title">Weekly Water Usage Trend</div>
          <div className="irr-bar-chart" style={{ height: 200 }}>
            {d.analytics.weekly.map(w => (
              <div key={w.week} className="irr-bar-col">
                <div className="irr-bar-val">{(w.water / 1000).toFixed(0)}k</div>
                <div className="irr-bar-wrap">
                  <div className="irr-bar-fill" style={{ height: `${(w.water / maxWeekly) * 100}%`, background: "linear-gradient(180deg,#3b82f6,#1d4ed8)" }} />
                </div>
                <div className="irr-bar-lbl" style={{ fontSize: 10 }}>{w.week}</div>
              </div>
            ))}
          </div>
        </div>
      )}

      {/* ── Zone Comparison ── */}
      {view === "Zone Comparison" && (
        <div className="irr-zone-cmp-card">
          <div className="irr-section-title">Zone Water Usage vs Efficiency — Today</div>
          <table className="irr-table">
            <thead>
              <tr><th>Zone</th><th>Crop Zone</th><th>Water Used (L)</th><th>Usage Bar</th><th>Efficiency</th><th>Efficiency Bar</th></tr>
            </thead>
            <tbody>
              {d.analytics.zoneComparison.map(z => (
                <tr key={z.zoneId}>
                  <td style={{ fontWeight: 600, color: "#667eea" }}>{z.zoneId}</td>
                  <td>{z.zone}</td>
                  <td>{z.water.toLocaleString()}</td>
                  <td style={{ minWidth: 120 }}><MiniBar value={z.water} max={maxZone} color={z.efficiency < 75 ? "#f59e0b" : "#3b82f6"} height={8} /></td>
                  <td style={{ color: z.efficiency >= 85 ? "#10b981" : z.efficiency >= 70 ? "#f59e0b" : "#ef4444", fontWeight: 600 }}>
                    {z.efficiency > 0 ? `${z.efficiency}%` : "—"}
                  </td>
                  <td style={{ minWidth: 120 }}><MiniBar value={z.efficiency} max={100} color={z.efficiency >= 85 ? "#10b981" : z.efficiency >= 70 ? "#f59e0b" : "#ef4444"} height={8} /></td>
                </tr>
              ))}
            </tbody>
          </table>
          <div className="irr-chart-footer">
            🏆 Most efficient: Nursery (94%) · ⚠ Attention: Pomegranate B (69%)
          </div>
        </div>
      )}

      {/* ── Cycle History ── */}
      {view === "Cycle History" && (
        <div className="irr-cycle-card">
          <div className="irr-section-title">Irrigation Cycle History</div>
          <table className="irr-table">
            <thead>
              <tr><th>Cycle ID</th><th>Zone</th><th>Start</th><th>End</th><th>Volume (L)</th><th>Status</th></tr>
            </thead>
            <tbody>
              {d.analytics.cycleHistory.map(c => (
                <tr key={c.id}>
                  <td style={{ fontWeight: 600, color: "#667eea" }}>{c.id}</td>
                  <td>{c.zone}</td>
                  <td style={{ fontSize: 12, color: "#6b7280" }}>{c.start}</td>
                  <td style={{ fontSize: 12, color: "#6b7280" }}>{c.end}</td>
                  <td style={{ fontWeight: 600 }}>{c.volume.toLocaleString()}</td>
                  <td>
                    <span className="irr-badge" style={{
                      background: c.status === "Active" ? "#dbeafe" : "#d1fae5",
                      color:      c.status === "Active" ? "#3b82f6" : "#10b981",
                    }}>{c.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};

export default IrrAnalyticsPanel;
